import { motion } from "framer-motion";
import { Phone, Mail } from "lucide-react";

export default function FundingCta() {
  return (
    <section className="relative py-20 lg:py-24 border-t border-[#D4AF37]/15" data-testid="funding-cta-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-[11px] tracking-[0.45em] uppercase text-[#D4AF37] mb-8"
          data-testid="funding-cta-overline"
        >
          Call for Funding Today
        </motion.p>
        <motion.a
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          href="tel:+18164056181"
          data-testid="funding-cta-phone-link"
          className="inline-flex items-center gap-4 font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#F5F5F5] hover:text-[#D4AF37] transition-colors duration-300"
        >
          <Phone size={36} strokeWidth={1} className="text-[#D4AF37] hidden sm:block" />
          816-405-6181
        </motion.a>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="mt-8"
        >
          <a
            href="mailto:funding@veritasdevelopmentgroupllc.com"
            data-testid="funding-cta-email-link"
            className="inline-flex items-center gap-2.5 text-sm font-light tracking-[0.15em] text-[#A3A3A3] hover:text-[#D4AF37] transition-colors duration-300"
          >
            <Mail size={14} strokeWidth={1.5} className="text-[#D4AF37]" />
            funding@veritasdevelopmentgroupllc.com
          </a>
        </motion.div>
      </div>
    </section>
  );
}
